export enum DataPool {
  VORAB = 'VORAB_DATEN',
}

export function isVorabDataPool(dataPool: DataPool): boolean {
  return dataPool === DataPool.VORAB;
}
